module.exports = {
  "version": "0.25.0"
};


//////////////////
// WEBPACK FOOTER
// ./~/@xdbchain/js-stellar-sdk/~/axios/lib/env/data.js
// module id = 239
// module chunks = 0